import ModalImport from '../../../../../Features/Modal/ModalImport';
import {ProModalProps} from '../../../../../Components/ProModal';
import {message} from 'antd';
import {importRoleUserExcel} from '../../service';

interface RoleAssignImportProps extends ProModalProps {}

export function RoleAssignImport({onOk, ...props}: RoleAssignImportProps) {
    async function onUpload(file: File) {
        await importRoleUserExcel(file);
        message.success('导入完成！');
        onOk?.();
    }

    return (
        <ModalImport
            {...props}
            onUpload={onUpload}
            title="导入授权人员"
            templateUrl={require('./授权人员模板.xlsx')}
            templateName="数据导入模板"
            restSteps={<div>2.&nbsp;在导入模板补充好数据后上传文件</div>}
        />
    );
}
